/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPayeeDrsPayeeQuicklayout.ts      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/payee-drs-payee-quicklayout";

export class AutogenModelPayeeDrsPayeeQuicklayout<RowType extends ModelRow> extends Endpoint<RowType, RowPayeeDrsPayeeQuicklayoutFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPayeeDrsPayeeQuicklayout extends ModelRow<RowPayeeDrsPayeeQuicklayoutFields> {
	constructor(values?: Partial<RowPayeeDrsPayeeQuicklayoutFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPayeeDrsPayeeQuicklayoutFields {
	city: string;
	dot_number: string;
	icc_number: string;
	id: string;
	intrastate_code: string;
	phone_number: string;
	state: string;
	zip_code: string;
}

